// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__EtwV8","opacity-transition":"success_opacity-transition__BPaQj"};